import { gql } from '@apollo/client'

export const CLONE_PROJECT = gql`
  mutation cloneProject($payload: JSON!) {
    cloneProjectAdmin(payload: $payload) {
      success
    }
  }
`
